'use client'

import { useEffect } from 'react'
import posthog from 'posthog-js'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/button'
import { Home } from 'iconsax-reactjs'
import { ANALYTICS_EVENTS } from '@/lib/analytics/events'
import { isServicesHostname } from '@/lib/config/spaces'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const t = useTranslations('errorPages.error')
  const router = useRouter()

  // This page sits above the space layouts, so home is wherever the visitor already was.
  const handleGoHome = () => {
    reset()
    router.push(
      isServicesHostname(window.location.hostname) ? '/' : '/internal'
    )
  }
  useEffect(() => {
    posthog.capture(ANALYTICS_EVENTS.exception, {
      error: error.message,
      stack: error.stack,
      digest: error.digest,
      type: 'next_error_boundary',
      service: 'frontend',
      transaction: window.location.pathname,
      url: window.location.href,
      userAgent: navigator.userAgent,
    })
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-surface-muted">
      <div className="max-w-2xl w-full text-center space-y-8">
        <div className="space-y-4">
          <h2 className="text-h3 text-balance text-content">{t('title')}</h2>
          <p className="text-lg text-content-secondary md:text-xl max-w-md mx-auto text-pretty leading-relaxed">
            {t('subtitle')}
          </p>
        </div>
        <div className="flex items-center justify-center gap-4 py-8">
          <div className="h-px w-16 bg-border" />
          <div className="h-1.5 w-1.5 rounded-full bg-accent" />
          <div className="h-px w-16 bg-border" />
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            onClick={reset}
            size="lg"
            variant="strong"
            className="min-w-[180px]"
          >
            {t('retry')}
          </Button>
          <Button
            onClick={handleGoHome}
            size="lg"
            variant="outline"
            className="min-w-[180px]"
          >
            <Home className="mr-2 h-5 w-5" />
            {t('goHome')}
          </Button>
        </div>
      </div>
    </div>
  )
}
